module.exports = __webpack_public_path__ + "static/BOTWelcome-2132b5f2ccc10be2fdda1602b3da65c0.png";